import { render } from "./SystemDesign.vue?vue&type=template&id=7773ea52&scoped=true&ts=true"
import script from "./SystemDesign.vue?vue&type=script&lang=ts"
export * from "./SystemDesign.vue?vue&type=script&lang=ts"

import "./SystemDesign.vue?vue&type=style&index=0&id=7773ea52&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7773ea52"]])

export default __exports__